import { Link, useLocation } from 'react-router-dom';
import styles from './MenuItem.module.css';

function MenuItem({ icon: Icon, label, to, isCollapsed }) {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <Link
            to={to}
            className={`${styles.menuItem} ${isActive ? styles.active : ''} ${isCollapsed ? styles.collapsed : ''}`}
        >
            <Icon className={styles.icon} />
            {!isCollapsed && <span className={styles.label}>{label}</span>}
        </Link>
    );
}

export default MenuItem;